import { Layout, PageIntro } from "../components/Chrome";
import { MaskedLines, Reveal } from "../components/Motion";
import { principles, processSteps } from "../data";

export default function Why() {
  return (
    <Layout>
      <PageIntro
        eyebrow="Why Moon Media"
        lines={[<>Less noise.</>, <>More <em>meaning.</em></>]}
        text="A creator partnership should feel like a natural extension of the brand — not a forced placement."
      />
      <section className="principles section-pad">
        {principles.map(([title, text], index) => (
          <Reveal as="article" key={title} className="principle" delay={(index % 2) * 0.08} data-testid={`principle-${index + 1}`}>
            <span>{`0${index + 1}`}</span>
            <h2>{title}</h2>
            <p>{text}</p>
          </Reveal>
        ))}
      </section>
      <section className="process-section">
        <div className="process-heading">
          <Reveal as="span" className="eyebrow eyebrow-gold" y={14}>The process</Reveal>
          <MaskedLines as="h2" inView lines={[<>A clear path from</>, <><em>brief to go-live.</em></>]} />
        </div>
        <div className="timeline" data-testid="process-timeline">
          {processSteps.map((step, i) => (
            <Reveal className="timeline-step" key={step} delay={i * 0.1} data-testid={`process-step-${i + 1}`}>
              <span>{`0${i + 1}`}</span>
              <h3>{step}</h3>
            </Reveal>
          ))}
        </div>
      </section>
    </Layout>
  );
}
